import Region from './region.js';

const center = new THREE.Vector2();
const dir0 = new THREE.Vector2();
const dir1 = new THREE.Vector2();

class Region2DElement extends Region {
    constructor(regionObject) {
        super();

        this._regionObject = regionObject;
    }

    getMidPosition() {
        let { x, y, width, height } = this._regionObject;

        return {
            x: x + width*0.5,
            y: y + height*0.5,
        };
    }

    isPointInside(position) {
        center.copy(position);
        let points = this._regionObject.points.reduce((acc, p) => acc.concat([p.x, p.y]), []);
        let pointCount = points.length/2;

        let angle = 0;

        for (let i0 = 0; i0 < pointCount; i0++) {
            let i1 = (i0+1) % pointCount;

            let x0 = points[i0*2+0], y0 = points[i0*2+1];
            let x1 = points[i1*2+0], y1 = points[i1*2+1];

            dir0.set(x0, y0).sub(center).normalize();
            dir1.set(x1, y1).sub(center).normalize();

            let sin = Math.min(Math.max(-1, dir0.x*dir1.y-dir0.y*dir1.x), 1);
            let cos = dir0.x*dir1.x+dir0.y*dir1.y;
            let segmentAngle = Math.atan2(sin, cos);
            angle += segmentAngle;
        }

        let windings = Math.round(angle/(Math.PI*2));
        return windings != 0;
    }

    getObject() {
        return this._regionObject;
    }
}

export default Region2DElement;
